import { UpdateCredsAction } from '@/redux/actions/authActions';
import { API } from '@/redux/config/index';
import { toast } from 'react-toastify';
import { useCustomerId } from '../../utils/hooks/useCustomerId';
import { setLocalStorageData } from '../../utils/LocalStorage';
import { StnAPI } from '../config/customHeadersApi';
import { raiseErrorException } from '../../utils/raiseErrorException';
import {
  getAllUsersStart,
  getQuickBooksEngineerIdStart,
  getUserByCurrentCustomerIdStart,
  getUserByCurrentCustomerIdStop,
  getUserByCustomerIdStart,
  getUserBySelectedCustomerIdStart,
  setAllUsers,
  setArchivedCustomerUsers,
  setCurrentCustomerNetworkingUsers,
  setCurrentCustomerSecurityUsers,
  setCurrentCustomerUsers,
  setDeletedUser,
  setErrorNew,
  setImportNewUser,
  setNewUser,
  setQuickBooksEngineer,
  setReducerError,
  setSelectedCustomerUsers,
  setToggleModal,
  setUser,
  start,
} from '../reducers/userReducer';

// Get aLl users
export const getAllUsers = () => async (dispatch) => {
  try {
    dispatch(getAllUsersStart());
    const response = await API.get('/users/');

    return dispatch(setAllUsers(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Create User
export const createUser = (data, setError, toggle, isOnboarding) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post('/users/', data);

    dispatch(setNewUser(response?.data));
    toggle();
    toast.success('New User Successfully Created!');
    toast.success('A verification email has been sent!');
    if (isOnboarding) {
      dispatch(getUserByCurrentCustomerID());
    }
  } catch (err) {
    // toast.error(err?.response?.data?.detail?.[0]?.msg || err?.response?.data?.detail);
    setError(err?.response?.data?.detail?.[0]?.msg || err?.response?.data?.detail);
    raiseErrorException(err, dispatch, setErrorNew, 'post');
  }
};

// import users
export const importUsers = (formData, toggle) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.post('/users/bulk', formData, {
      // headers: {
      //   'Content-Type': 'multipart/form-data',
      // },
    });
    dispatch(setImportNewUser(response?.data));
    dispatch(getUserByCurrentCustomerID());
    if (response.status == 207) {
      const allErrors = response?.data?.detail?.map((item) => item?.msg).join('\n');
      const blob = new Blob([allErrors], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'errors.txt';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      toast.info('All Error are Exported in  the text file.');
    }
    toggle();
  } catch (err) {
    const errorMsg = err?.response?.data?.detail[0]?.msg || err?.response?.data?.detail;
    // toast.error(errorMsg);
    raiseErrorException(err, dispatch, setErrorNew, 'post');
  }
};

// View a single user with ID
export const getUserByID = (userID) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/users/${userID}`);

    return dispatch(setUser(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// View a single user with ID
export const getQuickbooksEngineerByID = (userID) => async (dispatch) => {
  try {
    dispatch(getQuickBooksEngineerIdStart());
    const response = await API.get(`/users/${userID}`);

    return dispatch(setQuickBooksEngineer(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Update User with ID
export const updateUserByID =
  (
    firstName,
    lastName,
    email,
    password,
    phone,
    phone2,
    userID,
    redirectUrl,
    isPrimaryContact,
    logo = null,
    setError = null,
    isActive,
    isSecurityContact,
    isNetworkingContact,
  ) =>
  async (dispatch) => {
    try {
      // console.log('check_updateUserByID', {
      //   firstName,
      //   lastName,
      //   email,
      //   password,
      //   phone,
      //   phone2,
      //   userID,
      //   redirectUrl,
      //   isPrimaryContact,
      //   logo,
      //   isActive,
      // })
      if (logo) {
        const data = new FormData();
        data.append('file', logo);
        const profile = await API.put(`/users/${userID}/profile`, data);
      }
      const response = await API.put(`/users/${userID}`, {
        firstName,
        lastName,
        email,
        password,
        phone,
        phone2,
        userID,
        isActive,
        redirectUrl,
        isPrimaryContact,
        isSecurityContact,
        isNetworkingContact,
        isPasswordEncrypted: false,
      });

      dispatch(setUser(response?.data));
      toast.success('Updated Profile Successfully');
    } catch (err) {
      raiseErrorException(err, dispatch, setErrorNew);
    }
  };

// This updates the correct user after checking if the user.id === currentUser.id
export const updateCurrentUser =
  (
    firstName,
    lastName,
    email,
    password,
    phone,
    phone2,
    userID,
    redirectUrl,
    isPrimaryContact,
    logo,
    apiToken,
    refreshToken,
    setError,
    navigate,
    isActive,
    isSecurityContact,
    isNetworkingContact,
  ) =>
  async (dispatch) => {
    dispatch(
      updateUserByID(
        firstName,
        lastName,
        email,
        password,
        phone,
        phone2,
        userID,
        redirectUrl,
        isPrimaryContact,
        logo,
        setError,
        isActive,
        isSecurityContact,
        isNetworkingContact,
      ),
    ).then(() => dispatch(UpdateCredsAction(apiToken, refreshToken)));
  };

// Get Users by Customer ID
export const getUserByCurrentCustomerID = (customerID) => async (dispatch) => {
  try {
    dispatch(getUserByCurrentCustomerIdStart());

    const response = await API.get(`/users/customer?active=true`);

    return dispatch(setCurrentCustomerUsers(response?.data));
  } catch (err) {
    dispatch(getUserByCurrentCustomerIdStop());
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

export const getCurrentCompanySecurityUsers = (customerID) => async (dispatch) => {
  try {
    dispatch(getUserByCurrentCustomerIdStart());
    const response = await API.get(`/users/customer?active=true&filterSecurityContact=true`);
    return dispatch(setCurrentCustomerSecurityUsers(response?.data));
  } catch (err) {
    dispatch(getUserByCurrentCustomerIdStop());
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
export const updateCurrentCompanySecurityUsers = (data) => async (dispatch) => {
  try {
    await API.put(`/users/security_priority`, data);
    return;
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'put');
  }
};
export const getCurrentCompanyNetworkUsers = (customerID) => async (dispatch) => {
  try {
    dispatch(getUserByCurrentCustomerIdStart());
    const response = await API.get(`/users/customer?active=true&filterNetworkingContact=true`);
    return dispatch(setCurrentCustomerNetworkingUsers(response?.data));
  } catch (err) {
    dispatch(getUserByCurrentCustomerIdStop());
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};
export const updateCurrentCompanyNetworkUsers = (data) => async (dispatch) => {
  try {
    dispatch(start());
    await API.put(`/users/networking_priority`, data);
    return;
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};
// Get Users by Customer ID
export const getUsersBySelectedCustomerID = (customerID, cancelToken) => async (dispatch) => {
  try {
    const currentSiteID = useCustomerId();
    const API_URL = customerID ? StnAPI : API;
    console.log('API_URL', API_URL);

    dispatch(getUserBySelectedCustomerIdStart());
    const response = await API_URL.get(`/users/customer?active=true`, {
      headers: {
        'x-customer-id': customerID,
        'x-site-id': currentSiteID,
      },
      // cancelToken: cancelToken ? cancelToken.token : null,
    });
    // console.log('resp__', response.data)

    return dispatch(setSelectedCustomerUsers(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Get Archived Users by Customer ID
export const getArchivedUserByCustomerID = (customerID) => async (dispatch) => {
  try {
    dispatch(getUserByCustomerIdStart());
    const response = await API.get(`/users/customer?active=false`);

    return dispatch(setArchivedCustomerUsers(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

// Get User's SSO status
export const getUsersSsoStatus = (email) => async (dispatch) => {
  try {
    dispatch(start());
    const response = await API.get(`/users/email/${email}`);
    const customerID = response?.data?.customerID;
    const userID = response?.data?.userID;
    const enabledSso = response?.data?.enabledSso;
    const loginTime = new Date().getTime();
    const expirationTime = loginTime + 8 * 60 * 60 * 1000;
    setLocalStorageData('logoutTime', expirationTime);
    setLocalStorageData('loginTime', loginTime);
    setLocalStorageData('currentSiteID', 'all');

    return dispatch(
      setUser({
        customerID,
        userID,
        enabledSso,
        email,
      }),
    );
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError, 'get');
  }
};

export const activateAccount = (token, password, isPasswordEncrypted, navigate) => async (dispatch) => {
  try {
    await API.put('/users/activate_account/', {
      token,
      password,
      isPasswordEncrypted,
    });

    navigate('/login');
    toast.success('Your STN Portal account has been activated, please login.');
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};

// Archive User With ID
export const archiveUserByID = (userID, customerID) => async (dispatch) => {
  try {
    const response = await API.delete(`/users/${userID}/archive`);
    dispatch(getUserByCurrentCustomerID());
    dispatch(getArchivedUserByCustomerID(customerID));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};
// Unarchive User With ID
export const unarchiveUserByID = (userID, customerID) => async (dispatch) => {
  try {
    const response = await API.post(`/users/${userID}/unarchive`);
    dispatch(getUserByCurrentCustomerID());
    dispatch(getArchivedUserByCustomerID(customerID));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};

// Delete User With ID
export const deleteUserByID = (userID, customerID) => async (dispatch) => {
  try {
    const response = await API.delete(`/users/${userID}`);

    return dispatch(setDeletedUser(response?.data));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};

// Resend Verification Email
export const resendVerificationEmail = (customerID, userID) => async (dispatch) => {
  try {
    dispatch(start());
    await API.post(`/auth/verify_email?userID=${userID}`);

    return dispatch(getUserByID(userID));
  } catch (err) {
    raiseErrorException(err, dispatch, setReducerError);
  }
};

// Toggle the modal that adds users
export const toggleUserModal = () => async (dispatch) => {
  dispatch(setToggleModal());
};
